import React, { Component } from "react";
import PropTypes from "prop-types";

import BlueCheck from "../../../../../static/images/blue_check.svg";

class EnrolmentProgressBar extends Component {
  getSteps() {
    var steps = [];
    for (var i = 1; i <= 4; i++) {
      var classes =
        this.props.stepNumber == i
          ? "step current"
          : this.props.stepNumber > i
            ? "step step-done"
            : "step";
      var step =
        this.props.stepNumber > i ? (
          <img src={BlueCheck} alt={`Paso ${i}`} />
        ) : (
            i
          );

      steps.push(
        <div key={`step-key-${i}`} className={classes}>
          {step}
        </div>
      );
    }

    return steps;
  }

  render() {
    const { stepNumber, stepName } = this.props;
    return (
      <div className="progress-component">
        <div className="enrollment-container">
          <div className="progress-enrolment-bar">{this.getSteps()}</div>
        </div>
        <h2>
          Paso {stepNumber} de 4: <strong>{stepName}</strong>
        </h2>
      </div>
    )
  }
}

EnrolmentProgressBar.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  stepName: PropTypes.string.isRequired,
};

export default EnrolmentProgressBar;
